import React from 'react';
import { Box, Typography, Tooltip } from '@mui/material';
import { VerifiedUser } from '@mui/icons-material';

interface VerifiedBadgeProps {
  isVerified: boolean;
  size?: 'small' | 'medium' | 'large';
  showText?: boolean;
  position?: 'avatar' | 'inline';
}

const VerifiedBadge: React.FC<VerifiedBadgeProps> = ({ 
  isVerified, 
  size = 'medium', 
  showText = false, 
  position = 'inline' 
}) => {
  if (!isVerified) return null;

  const getSizeConfig = () => {
    switch (size) {
      case 'small':
        return { iconSize: 16, fontSize: 12, padding: 0.5 };
      case 'large':
        return { iconSize: 32, fontSize: 16, padding: 1 };
      default:
        return { iconSize: 24, fontSize: 14, padding: 0.75 };
    }
  };

  const { iconSize, fontSize, padding } = getSizeConfig();

  if (position === 'avatar') {
    return (
      <Tooltip title="Profil vérifié" arrow>
        <Box
          sx={{
            position: 'absolute',
            bottom: 0,
            right: 0,
            backgroundColor: '#4caf50',
            borderRadius: '50%',
            width: iconSize + 8,
            height: iconSize + 8,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            border: '3px solid white',
            boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
            zIndex: 1
          }}
        >
          <VerifiedUser sx={{ color: 'white', fontSize: iconSize }} />
        </Box>
      </Tooltip>
    );
  }

  return (
    <Tooltip title="Profil vérifié" arrow>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
        <VerifiedUser sx={{ color: '#4caf50', fontSize: iconSize }} />
        {showText && (
          <Typography 
            variant="body2" 
            sx={{ 
              color: '#4caf50', 
              fontWeight: 'bold',
              fontSize: fontSize
            }}
          >
            Vérifié
          </Typography>
        )}
      </Box>
    </Tooltip>
  );
};

export default VerifiedBadge;
